import React from "react";
import {
  JetonStyled,
  AmountStyled,
  BalanceStyled,
  InsertedDateStyled,
  DescriptionStyled,
} from "./jetons.style";
import { toPersianNum } from "../../assets/utils";
const Jetons = ({ jeton }) => {
  //   console.log("jeton", jeton);
  // const [amount, balance, description, persian_inserted_on,in_or_out] = jeton;
  return (
    <>
      {jeton && (
        <JetonStyled>
          <AmountStyled color={jeton.in_or_out}>
            {jeton.in_or_out
              ? `${toPersianNum(jeton.amount)} + `
              : `${toPersianNum(jeton.amount)} - `}
          </AmountStyled>
          <BalanceStyled>
            <div>موجودی</div>
            <div>{toPersianNum(jeton.balance)}</div>
          </BalanceStyled>
          <InsertedDateStyled>
            {toPersianNum(jeton.persian_inserted_on)}
          </InsertedDateStyled>
          <DescriptionStyled>{jeton.description}</DescriptionStyled>
        </JetonStyled>
      )}
    </>
  );
};

export default Jetons;
